var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.759 2.984a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5m-10.75 9.25c0-5.937 4.813-10.75 10.75-10.75s10.75 4.813 10.75 10.75-4.813 10.75-10.75 10.75-10.75-4.813-10.75-10.75m11.05-4.222a2.25 2.25 0 0 0-2.503 1.47.75.75 0 0 1-1.415-.497 3.75 3.75 0 0 1 7.288 1.25c0 1.397-1.039 2.343-1.834 2.873a7.8 7.8 0 0 1-1.631.82l-.033.012-.01.003-.003.002h-.001l-.238-.711.237.711a.75.75 0 0 1-.476-1.422h.001l.002-.001.018-.007.08-.029a6.295 6.295 0 0 0 1.222-.626c.704-.47 1.166-1.024 1.166-1.626v-.001a2.25 2.25 0 0 0-1.87-2.221m3.37 2.222h-.75zm-3.67 6.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgHelp;